var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYouTube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 30,
    viewBox: "0 0 41 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1393_2960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.1536 5.22012C39.6879 3.47222 38.3157 2.09582 36.5731 1.62869C33.4148 0.779732 20.75 0.779732 20.75 0.779732C20.75 0.779732 8.0853 0.779732 4.9269 1.62869C3.18441 2.09582 1.81201 3.47222 1.3463 5.22012C0.5 8.38806 0.5 14.9978 0.5 14.9978C0.5 14.9978 0.5 21.6074 1.3463 24.7756C1.81201 26.5233 3.18441 27.8997 4.9269 28.3671C8.0853 29.2158 20.75 29.2158 20.75 29.2158C20.75 29.2158 33.4148 29.2158 36.5731 28.3671C38.3157 27.8997 39.6879 26.5233 40.1536 24.7756C41 21.6074 41 14.9978 41 14.9978C41 14.9978 41 8.38806 40.1536 5.22012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6016 20.9985L27.1868 14.9977L16.6016 8.99633V20.9985Z",
    fill: "#13121D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1393_2960"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.5,
    height: 28.4361,
    fill: "white",
    transform: "translate(0.5 0.781738)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/YouTube.90a0225238969b420b6a777c960a2e9c.svg";
export { ForwardRef as ReactComponent };